// Atoms
import * as ajaxLoader from './atoms/ajax-loader/ajax-loader';
import * as armyLogoAdt from './atoms/army-logo-adt/army-logo-adt';
import * as armyLogoMda from './atoms/army-logo-mda/army-logo-mda';
import * as blockquoteStandard from './atoms/blockquote-standard/blockquote-standard';
import * as buttonBurgerMenu from './atoms/button-burger-menu/button-burger-menu';
import * as buttonCalendar from './atoms/button-calendar/button-calendar';
import * as buttonChat from './atoms/button-chat/button-chat';
import * as buttonClose from './atoms/button-close/button-close';
import * as buttonContact from './atoms/button-contact/button-contact';
import * as buttonDisabled from './atoms/button-disabled/button-disabled';
import * as buttonDownload from './atoms/button-download/button-download';
import * as buttonPrimary from './atoms/button-primary/button-primary';
import * as buttonSearch from './atoms/button-search/button-search';
import * as buttonSecondary from './atoms/button-secondary/button-secondary';
import * as buttonSocial from './atoms/button-social/button-social';
import * as itemLocation from './atoms/item-location/item-location';
import * as itemTip from './atoms/item-tip/item-tip';
import * as itemTooltip from './atoms/item-tooltip/item-tooltip';
import * as siteLogo from './atoms/site-logo/site-logo';
import * as textStyles from './atoms/text-styles/text-styles';
export let atoms = {
  ajaxLoader,
  armyLogoAdt,
  armyLogoMda,
  blockquoteStandard,
  buttonBurgerMenu,
  buttonCalendar,
  buttonChat,
  buttonClose,
  buttonContact,
  buttonDisabled,
  buttonDownload,
  buttonPrimary,
  buttonSearch,
  buttonSecondary,
  buttonSocial,
  itemLocation,
  itemTip,
  itemTooltip,
  siteLogo,
  textStyles,
};

// Molecules
import * as armsCoat from './molecules/arms-coat/arms-coat';
import * as armyLogos from './molecules/army-logos/army-logos';
import * as blockKeyPoint from './molecules/block-key-point/block-key-point';
import * as blockDocument from './molecules/block-document/block-document';
import * as blockOpeningHours from './molecules/block-opening-hours/block-opening-hours';
import * as blockPayment from './molecules/block-payment/block-payment';
import * as blockPathmotion from './molecules/block-pathmotion/block-pathmotion';
import * as blockStep from './molecules/block-step/block-step';
import * as contextualInfos from './molecules/contextual-infos/contextual-infos';
import * as editorialWysiwyg from './molecules/editorial-wysiwyg/editorial-wysiwyg';
import * as jobGrade from './molecules/job-grade/job-grade';
import * as jobMenu from './molecules/job-menu/job-menu';
import * as languageSwitcher from './molecules/language-switcher/language-switcher';
import * as layerKeyfigure from './molecules/teaser-keyfigure/teaser-keyfigure';
import * as listAccess from './molecules/list-access/list-access';
import * as listDriver from './molecules/list-driver/list-driver';
import * as listPager from './molecules/list-pager/list-pager';
import * as listSelect from './molecules/list-select/list-select';
import * as logoRecruitment from './molecules/logo-recruitment/logo-recruitment';
import * as mainMenu from './molecules/main-menu/main-menu';
import * as menuLinks from './molecules/menu-links/menu-links';
import * as menuLegals from './molecules/menu-legals/menu-legals';
import * as menuSocials from './molecules/menu-socials/menu-socials';
import * as mediaGallery from './molecules/media-gallery/media-gallery';
import * as mediaSlider from './molecules/media-slider/media-slider';
import * as navTab from './molecules/nav-tab/nav-tab';
import * as openingStatus from './molecules/opening-status/opening-status';
import * as pageBreadcrumbs from './molecules/page-breadcrumbs/page-breadcrumbs';
import * as pageHeading from './molecules/page-heading/page-heading';
import * as stepsPayment from './molecules/steps-payment/steps-payment';
import * as siblingsSwitcher from './molecules/siblings-switcher/siblings-switcher';
import * as stepsCheckout from './molecules/steps-checkout/steps-checkout';
import * as systemMessage from './molecules/system-message/system-message';
import * as tabSecondary from './molecules/tab-secondary/tab-secondary';
import * as teaserCard from './molecules/teaser-card/teaser-card';
import * as teaserEdito from './molecules/teaser-edito/teaser-edito';
import * as teaserFocus from './molecules/teaser-focus/teaser-focus';
import * as teaserImage from './molecules/teaser-image/teaser-image';
import * as teaserMain from './molecules/teaser-main/teaser-main';
import * as teaserSecondary from './molecules/teaser-secondary/teaser-secondary';
import * as teaserStandard from './molecules/teaser-standard/teaser-standard';
import * as teaserVideo from './molecules/teaser-video/teaser-video';
export let molecules = {
  armsCoat,
  armyLogos,
  blockKeyPoint,
  blockDocument,
  blockOpeningHours,
  blockPayment,
  blockPathmotion,
  blockStep,
  contextualInfos,
  editorialWysiwyg,
  jobGrade,
  jobMenu,
  layerKeyfigure,
  languageSwitcher,
  listAccess,
  listDriver,
  listPager,
  listSelect,
  logoRecruitment,
  mainMenu,
  menuLinks,
  menuLegals,
  menuSocials,
  mediaGallery,
  mediaSlider,
  navTab,
  openingStatus,
  pageBreadcrumbs,
  pageHeading,
  stepsPayment,
  siblingsSwitcher,
  stepsCheckout,
  systemMessage,
  tabSecondary,
  teaserCard,
  teaserEdito,
  teaserFocus,
  teaserImage,
  teaserMain,
  teaserSecondary,
  teaserStandard,
  teaserVideo,
};

// Organisms
import * as accordionList from './organisms/accordion-list/accordion-list';
import * as blockButtonLink from './organisms/block-button-link/block-button-link';
import * as blockFocus from './organisms/block-focus/block-focus';
import * as blockHighlight from './organisms/block-highlight/block-highlight';
import * as contactTools from './organisms/contact-tools/contact-tools';
import * as formPosition from './organisms/form-position/form-position';
import * as homeBanner from './organisms/home-banner/home-banner';
import * as jobAdvantages from './organisms/job-advantages/job-advantages';
import * as layerAccess from './organisms/layer-access/layer-access';
import * as layerOpeningHours from './organisms/layer-opening-hours/layer-opening-hours';
import * as layerPathmotion from './organisms/layer-pathmotion/layer-pathmotion';
import * as listKeyPoints from './organisms/list-key-points/list-key-points';
import * as listCirfa from './organisms/list-cirfa/list-cirfa';
import * as listColumns from './organisms/list-columns/list-columns';
import * as listCross from './organisms/list-cross/list-cross';
import * as listEdito from './organisms/list-edito/list-edito';
import * as listFocus from './organisms/list-focus/list-focus';
import * as listKeyfigures from './organisms/list-keyfigures/list-keyfigures';
import * as listLinks from './organisms/list-links/list-links';
import * as listPreview from './organisms/list-preview/list-preview';
import * as listRows from './organisms/list-rows/list-rows';
import * as listSteps from './organisms/list-steps/list-steps';
import * as listTips from './organisms/list-tips/list-tips';
import * as listZoom from './organisms/list-zoom/list-zoom';
import * as maintenancePage from './organisms/maintenance-page/maintenance-page';
import * as pageHighlights from './organisms/page-highlights/page-highlights';
import * as panelRight from './organisms/panel-right/panel-right';
// tslint:disable-next-line
//import * as quickSearch from './organisms/quick-search/quick-search';
import * as siteFooter from './organisms/site-footer/site-footer';
import * as siteHeader from './organisms/site-header/site-header';
import * as siteMap from './organisms/site-map/site-map';
import * as standardForm from './organisms/standard-form/standard-form';
import * as tabsPrimary from './organisms/tabs-primary/tabs-primary';
import * as tabsSecondary from './organisms/tabs-secondary/tabs-secondary';
import * as viewJobs from './organisms/view-jobs/view-jobs';
export let organisms = {
  accordionList,
  blockButtonLink,
  blockFocus,
  blockHighlight,
  contactTools,
  formPosition,
  homeBanner,
  jobAdvantages,
  layerAccess,
  layerOpeningHours,
  layerPathmotion,
  listKeyPoints,
  listCirfa,
  listColumns,
  listCross,
  listEdito,
  listFocus,
  listKeyfigures,
  listLinks,
  listPreview,
  listRows,
  listSteps,
  listTips,
  listZoom,
  maintenancePage,
  pageHighlights,
  panelRight,
  // tslint:disable-next-line
  // quickSearch,
  siteFooter,
  siteHeader,
  siteMap,
  standardForm,
  tabsPrimary,
  tabsSecondary,
  viewJobs,
};
